import React, { useState, useEffect } from 'react';
import { FrenkitSearchProps } from './interfaces/FrenkitSearchProps';
import CountrySelector from './components/CountrySelector';
import { IconSearch } from './icons/Icons';
import VehicleTypeSelector from "./components/VehicleTypeSelector";
import { useTranslation } from 'react-i18next';
import { getConfig } from './config'; // Importamos la función getConfig

const FrenkitSearch: React.FC<FrenkitSearchProps> = ({ language, vehicle_type, country_code, reference }) => {
    const [referenceValue, setReferenceValue] = useState(reference);
    const [message, setMessage] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [countryCode, setCountryCode] = useState<'eu' | 'latam' | 'us'>(country_code ? country_code : 'eu');
    const [vehicleType, setVehicleType] = useState<'auto' | 'moto' | 'performance'>(vehicle_type ? vehicle_type : 'auto');
    const { t } = useTranslation();
    const [apiUrl, setApiUrl] = useState<string | null>(null); // Estado para almacenar la URL de la API
    // useEffect para obtener la URL de la API cuando el componente se monta
    useEffect(() => {
        const fetchApiUrl = async () => {
            try {
                const url = await getConfig();
                setApiUrl(url); // Guardar la URL obtenida en el estado
            } catch (error) {
                setMessage(t("message_api_url_not_found"));
            }
        };
        fetchApiUrl();
    }, [t]); // Dependencia t porque la función de traducción puede cambiar

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setReferenceValue(e.target.value);
    };

    const handleCountryChange = (code: 'eu' | 'latam' | 'us') => {
        setCountryCode(code);
    };

    const handleVehicleTypeChange = (vehicle_type: 'auto' | 'moto' | 'performance') => {
        setVehicleType(vehicle_type);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        if (!apiUrl) {
            setMessage(t("message_api_url_not_found"));
            setLoading(false);
            return;
        }
        try {
            let url = `${apiUrl}/getreference/reference=${referenceValue}&country_code=${countryCode}&vehicle_type=${vehicleType}`;
            const response = await fetch(url);
            const data = await response.json();
            if (response.ok && (data.other_catalogs || data.other_vehicles || data.length > 0)) {
                if (data.other_catalogs && data.other_vehicles) {
                    setMessage("Se encuentra en otro catálogo y otro tipo de vehículo");
                } else if (data.other_catalogs) {
                    setMessage("Se encuentra en otro catálogo");
                } else if (data.other_vehicles) {
                    setMessage("Se encuentra en otro tipo de vehículo");
                } else if (data[0].cproducto) {
                    const { country_code, vehicle_type } = data[0];
                    const redirectUrl = `/${vehicle_type}/catalogo/${country_code}/${referenceValue}`;
                    window.location.href = redirectUrl;
                }
            } else {
                setMessage("Referencia no encontrada");
            }
        } catch (error) {
            setMessage(t("message_reference_not_found"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <CountrySelector countryCode={countryCode} vehicleType={vehicleType} onCountryChange={handleCountryChange} />
            <VehicleTypeSelector vehicleType={vehicleType} onCountryChange={handleVehicleTypeChange} />
            <div>
                <form onSubmit={handleSubmit} className="flex h-[45px]">
                    <input type="text" value={referenceValue} onChange={handleInputChange} placeholder="Búsqueda por artículo Frenkit, kit de reparación y pinza OEM ..." className="w-full px-3 py-2 text-base" />
                    <button type="submit" className="w-[52px] bg-yellow flex justify-center items-center"><IconSearch height="18px" /></button>
                </form>

                {loading && <p className="mt-4">Cargando...</p>}

                {message && (
                    <div className="mt-4">
                        <p>{message}</p>
                    </div>
                )}
            </div>
        </>
    );
};

export default FrenkitSearch;